module.exports = __webpack_public_path__ + "img/202602_01.4399e572.png";